import React from "react";
import { Alert, Box, Checkbox, CircularProgress, FormControlLabel, Typography } from "@mui/material";
import { normalizeIdArray } from "../utils/companyUtils";

export default function SectionSimpleLookup({
                                                form,
                                                setForm,
                                                field,
                                                items,
                                                loading,
                                                error,
                                                emptyText,
                                            }) {
    const activeItems = React.useMemo(
        () => (items || []).filter((item) => item.is_active === undefined || !!item.is_active),
        [items]
    );

    const selectedIds = normalizeIdArray(form[field]);

    const toggleItem = (id) => {
        setForm((f) => {
            const ids = new Set(normalizeIdArray(f[field]));
            if (ids.has(id)) ids.delete(id);
            else ids.add(id);
            return { ...f, [field]: Array.from(ids).sort((a, b) => a - b) };
        });
    };

    if (error) {
        return <Alert severity="error">{error}</Alert>;
    }

    if (loading) {
        return (
            <Box sx={{ py: 2, textAlign: "center" }}>
                <CircularProgress size={20} />
            </Box>
        );
    }

    if (!activeItems.length) {
        return <Alert severity="info">{emptyText}</Alert>;
    }

    return (
        <Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
                {selectedIds.length} von {activeItems.length} ausgewählt
            </Typography>

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, minmax(0, 1fr))",
                        md: "repeat(3, minmax(0, 1fr))",
                        lg: "repeat(4, minmax(0, 1fr))",
                    },
                    gap: 0.25,
                    maxHeight: 220,
                    overflowY: "auto",
                    pr: 1,
                    py: 0.5,
                }}
            >
                {activeItems.map((item) => {
                    const id = Number(item.id);
                    const checked = selectedIds.includes(id);
                    const label = item.label_de || item.name;
                    return (
                        <FormControlLabel
                            key={item.id}
                            control={
                                <Checkbox
                                    size="small"
                                    checked={checked}
                                    onChange={() => toggleItem(id)}
                                    sx={{ py: 0.5 }}
                                />
                            }
                            label={label}
                            sx={{
                                m: 0,
                                minWidth: 0,
                                borderRadius: 1,
                                px: 0.75,
                                py: 0.25,
                                bgcolor: checked ? "rgba(240, 172, 77, 0.10)" : "transparent",
                                "&:hover": { bgcolor: "action.hover" },
                                "& .MuiFormControlLabel-label": {
                                    fontSize: "0.875rem",
                                    lineHeight: 1.25,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                            }}
                        />
                    );
                })}
            </Box>
        </Box>
    );
}
